/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1FeedbackId200,
  GetApiV1FeedbackId401,
  GetApiV1FeedbackId404,
  GetApiV1FeedbackId500,
  GetApiV1FeedbackIdPathParams,
  GetApiV1FeedbackIdQueryResponse,
} from "../../types/feedbackRegistroController/GetApiV1FeedbackId.ts";
import { feedbackViewModelSchema } from "../feedbackViewModelSchema.ts";

export const getApiV1FeedbackIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1FeedbackIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1FeedbackId200Schema = z.lazy(
  () => feedbackViewModelSchema,
) as unknown as ToZod<GetApiV1FeedbackId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1FeedbackId401Schema =
  z.any() as unknown as ToZod<GetApiV1FeedbackId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1FeedbackId404Schema =
  z.any() as unknown as ToZod<GetApiV1FeedbackId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1FeedbackId500Schema =
  z.any() as unknown as ToZod<GetApiV1FeedbackId500>;

export const getApiV1FeedbackIdQueryResponseSchema = z.lazy(
  () => getApiV1FeedbackId200Schema,
) as unknown as ToZod<GetApiV1FeedbackIdQueryResponse>;
